import api, { Notifiable } from '../api';

const controller = 'crfRequisitadoOc';

export interface DistribuicaoRequisitado {
  resultDataTabel: RequisitadoAno[];
  anos: number[];
}

export interface RequisitadoAno {
  pcmId: string;
  requisicaoCompraSeqId: string;
  crfContaContabilCcId: string;
  crfContaContabilCcRequisicaoCompraSeqId: string;
  moduloEconomicoContratadoId: string;
  ordemCompraId: string;

  crfContaContabilCcRequisicaoCompraSeqPrincial: boolean;

  pacoteProjeto: string;
  pacotePctOi: string;

  requisicaoCompraNumero: number;
  requisicaoCompraSeq: string;
  requisicaoCompraPrecoUnitarioFormatado: string;
  requisicaoCompraPrecoUnitario: number;
  requisicaoCompraQuantidadeTotal: string;
  requisicaoCompraValorTotal: number;
  requisicaoCompraValorTotalFormatado: string;
  requisicaoCompraOc: string;

  pedidoPcm: string;
  pedidoCtPcs: string;
  pedidoCtPreUnitarioFormatado: string;
  valorUnitarioPedido: number;

  valorFormatado: string;
  quantidadeFormatado: string;
}

export interface Filter {
  codigoCentroCustoFormulario: string,
  nomeCentroCustoFormulario: string,
  statusModuloEconomicoRequisitadoFormulario: string[],
  codigoAgrupadorFormulario: string,
  contaContabilFormulario: string,
  numeroRequisicaoCompraFormulario: number,
  numeroItemRequisicaoCompraFormulario: number,
  statusRequisicaoCompraFormulario: string[],
  dataRequisicaoCompraFormulario: Date,
}

export interface RequisitadoRc {
  numero: string;
  codigoContaContabil: string;
  codigoPacote: string;
  codigoAgrupador: string;
  nome: string;
  rcStatus: string;
  requisicaoCompraValorTotal: number;
  requisicaoCompraValorTotalFormatado: string;
  valorTotalFormatado: string;
  index: number;
  crfContaContabilCcId: string;
  requisitadoComOrdemDeCompra: RequisitadoComOrdemCompra[];
  requisitadoSemOndemDeCompra: RequisitadoSemOrdemCompra[];
}

export interface RequisitadoSemOrdemCompra {
  narrativa: string;
  requisicaoCompraNumero: number;
  requisicaoCompraSeq: number;
  requisicaoCompraValorTotal: string;
  requisicaoCompraValorTotalFormatado: string;
  valorParaDistribuidoFormatado: string;
  valorDistribuidoFormatado: string;
  distribuidoTotalFormatado: string;
  ordemInvestimentoId: string;
  principalFormatado: string;
  index: number;
}

export interface RequisitadoComOrdemCompra {
  narrativa: string;
  requisicaoCompraNumero: number;
  requisicaoCompraSeq: number;
  requisicaoCompraValorTotal: string;
  requisicaoCompraValorTotalFormatado: string;
  valorParaDistribuidoFormatado: string;
  valorDistribuidoFormatado: string;
  distribuidoTotalFormatado: string;
  ordemInvestimentoId: string;
  principalFormatado: string;
  requisicaoCompraOc: string;
  index: number;
}

export interface RequisitadoRcData {

}

export interface RequisitadoOcData {

}


export const getAllRequisitadoRc = (values: Filter = {}) => {
  return api.post<RequisitadoRcData[]>(`${controller}/getAllRequisitadoRc`, values, {
    disableNotification: 'true',
  });
};

export const getAllRequisitadoOcData = (values: Filter = {}) => {
  return api.post<RequisitadoOcData[]>(`${controller}/getAllRequisitadoOc`, values, {
    disableNotification: 'true',
  });
};

export const getAllRequisitadoAnoRc = (id: any) =>
  api.get<DistribuicaoRequisitado>(`${controller}/getAllRequisitadoAnoRc/${id}`);

export const getAllRequisitadoAnoOc = (id: any) =>
  api.get<DistribuicaoRequisitado>(`${controller}/getAllRequisitadoAnoOc/${id}`);

export const deleteRequisitadoAno = (id: any) => api.get<Notifiable>(`${controller}/deleteRequisitadoAno/${id}`);

export const adicionarLinhaItemRateavelRequisitadoAno = (
  crfContaContabilCcId: any,
  crfContaContabilCcRequisicaoCompraSeqId: string,
) => {
  const form = new FormData();
  form.append('crfContaContabilCcId', crfContaContabilCcId);
  form.append('crfContaContabilCcRequisicaoCompraSeqId', crfContaContabilCcRequisicaoCompraSeqId);

  return api.post<any>(`${controller}/adicionarLinhaItemRequisitadoAno`, form);
};

export const adicionarColunaItemRateavelRequisitadoAnoOc = (crfContaContabilCcRequisicaoCompraSeqId: any) => {
  const form = new FormData();
  form.append('crfContaContabilCcRequisicaoCompraSeqId', crfContaContabilCcRequisicaoCompraSeqId);

  return api.post<any>(`${controller}/adicionarColunaItemRequisitadoAnoOc`, form);
};

export const adicionarColunaItemRequisitadoAnoRc = (crfContaContabilCcRequisicaoCompraSeqId: any) => {
  const form = new FormData();
  form.append('crfContaContabilCcRequisicaoCompraSeqId', crfContaContabilCcRequisicaoCompraSeqId);

  return api.post<any>(`${controller}/adicionarColunaItemRequisitadoAnoRc`, form);
};

export const atualizarValorRequisitadoAno = (
  crfContaContabilCcRequisicaoCompraSeqId: any,
  valorAlterado: string,
  ano: string,
) => {
  const form = new FormData();
  form.append('crfContaContabilCcRequisicaoCompraSeqId', crfContaContabilCcRequisicaoCompraSeqId);
  form.append('valorAlterado', valorAlterado);
  form.append('valorAlteradoDecimal', valorAlterado);
  form.append('ano', ano);
  form.append('anoTexto', ano);

  return api.post<any>(`${controller}/atualizarValorRequisitadoAno`, form);
};

export const concluirRateioOcRc = (ordemInvestimentoRequisicaoCompraSeqId: string) => {
  const form = new FormData();
  form.append('crfContaContabilCcRequisicaoCompraSeqId', ordemInvestimentoRequisicaoCompraSeqId);
  return api.post<any>(`${controller}/concluirRateioOcRc`, form);
};


export const getAllRequisitoProjeto = (id: any) =>
  api.get<RequisitadoRc[]>(`${controller}/requisitadoRcByProjetoId/${id}`);

export const getAllRequisitoSemOrdemCompraProjeto = (id: any) =>
  api.get<RequisitadoSemOrdemCompra[]>(`${controller}/requisitadoCompraByProjetoId/${id}`);

export const getAllRequisitoComOrdemCompraProjeto = (id: any) =>
  api.get<RequisitadoComOrdemCompra[]>(`${controller}/requisitadoComOrdemCompraByProjetoId/${id}`);